<template>
  <div style="height: 300px; width: 100%; border-radius: 10px; overflow: hidden">
    <l-map
      ref="map"
      :zoom="zoom"
      :center="mapCenter"
      :use-global-leaflet="false"
      :bounds="mapBounds"
    >
      <l-tile-layer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        layer-type="base"
        name="OpenStreetMap"
      ></l-tile-layer>
      <l-marker ref="marker" :lat-lng="markerCoordinates" @dragend="handleMarkerUpdate()">
      </l-marker>
    </l-map>
  </div>
</template>

<script setup lang="ts">
  import { onMounted, ref, toRefs, watch } from 'vue';
  import { LMap, LMarker, LTileLayer } from '@vue-leaflet/vue-leaflet';
  import 'leaflet/dist/leaflet.css';

  export interface Props {
    height?: string | number;
    zoom?: number;
    location?: {
      lat?: number;
      lon?: number;
    };
  }

  const props = withDefaults(defineProps<Props>(), {
    height: '300',
    zoom: 12,
    location: () => ({
      lat: 40.416779,
      lon: -3.703492,
    }),
  });

  const marker = ref();

  const handleMarkerUpdate = async () => {
    mapCenter.value = marker.value.leafletObject._latlng;
  };

  const mapBounds = ref(undefined);
  const height = toRefs(props).height;

  const defaultLocation = {
    lat: 40.416779,
    lon: -3.703492,
  };

  const DEFAULT_COORDINATES = [
    props?.location?.lat || defaultLocation.lat,
    props?.location?.lon || defaultLocation.lon,
  ];

  const map = ref();
  const markerCoordinates = ref(DEFAULT_COORDINATES);
  const mapCenter = ref(DEFAULT_COORDINATES);

  onMounted(() => {
    if (map.value && map.value.root) map.value.root.style.height = `${props.height}px`;
  });

  watch(
    props,
    () => {
      markerCoordinates.value = [
        props?.location?.lat || defaultLocation.lat,
        props?.location?.lon || defaultLocation.lon,
      ];
      mapCenter.value = [
        props?.location?.lat || defaultLocation.lat,
        props?.location?.lon || defaultLocation.lon,
      ];
    },
    {
      deep: true,
    },
  );

  watch(height, () => {
    if (map.value && map.value.root) map.value.root.style.height = `${props.height}px`;
  });
</script>

<style></style>
